module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-stone-path.30f943aa.png";